/**
 * @desc 平台店铺应用表更新
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.AppAccountRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/appAccount/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
